import * as React from "react";
import QuickLinks from "../components/QuickLinks";
import CustomNotification from "../components/CustomNotification";
import Recalculate from "../components/Recalculate";

const EditorWarning: React.FC = () => {
  const { isOwnerLoggedIn, ownerEmail } = JSON.parse(localStorage.getItem("ownerDetails") || "{}");

  return (
    <>
      <CustomNotification
        label={
          !ownerEmail
            ? "It appears that you're logged into multiple Google accounts. To continue, please sign out of all accounts and sign in again."
            : isOwnerLoggedIn
            ? `This spreadsheet is connected to the Fundwave account of ${ownerEmail}.`
            : `Oops! Seems like this spreadsheet is disconnected from Fundwave. Please request the owner of the spreadsheet (${ownerEmail}) to connect.`
        }
      />
      <Recalculate />
      <QuickLinks />
    </>
  );
};

export default EditorWarning;
